import { connect } from 'react-redux'
import LeftPanel from './LeftPanel'
import { state_start_over,state_update } from '../actions'
import {decodeHtml} from '../reducers/utils'
import ReactGA from 'react-ga';
import smoothscroll from 'smoothscroll-polyfill';

window.__forceSmoothScrollPolyfill__ = true;
smoothscroll.polyfill();

const mapStateToProps = (state, ownProps) => ({
  title:state['initial']===''?(decodeHtml(state['title']) === ''? '': decodeHtml(state['title'])):'', //decodeHtml(state['title']),
  cfg:state['cfg1'],
  sh: state['sh'],
  type: state['type'],
  sku: state['sku'],
  isku: state['initialSku']
})
  
const mapDispatchToProps = (dispatch, ownProps) => ({
  onStartOver: ( () =>{
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    ReactGA.event({
      category: 'StartOver',
      action:'StartOver' 
    });
    dispatch(state_start_over())}),
  onPushOpenBox: ( () =>{
    ReactGA.event({
      category: 'Zoom',
      action:'Zoom' 
    });
    dispatch(state_update({attr:'pushOpenBox',value:true}))})
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LeftPanel)


// WEBPACK FOOTER //
// ./src/layout/LeftPanelWrap.js